<template>
  <div class="container wow fadeIn top-buffer">
    <div class="container my-3">
      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">Utilities</span>
      </h4>
      <hr />
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="row row-grid">
            <div
              class="col-lg-3 col-mb-3 mb-2"
              v-for="(item, index) in products"
              :key="index"
            >
              <router-link
                :to="{
                  path: item.urlPath,
                  query: {
                    portiFolio: item.portiFolio,
                    c: isoCountry,
                  },
                }"
              >
                <b-card
                  class="border-1 text-center"
                  border-variant="dark"
                  hover
                >
                  <icon
                    v-if="item.icon"
                    :name="item.icon"
                    size="lg"
                    class="mb-4"
                    color="primary"
                    shadow
                    rounded
                    variant="info"
                  >
                  </icon>
                  <img
                    v-if="item.iconImg"
                    :src="item.iconImg"
                    height="85px"
                    alt="item.text"
                  />
                  <h6 class="text-uppercase">
                    {{ item.text }}
                  </h6>
                </b-card>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import prdts from "@/settings/products";

export default {
  data: function () {
    return {
      products: null,
      isoCountry: "",
    };
  },
  mounted() {
    this.isoCountry = this.$route.query.c;
    if (this.isoCountry === undefined) {
      this.$router.push({ name: "Country" });
      return;
    }

    this.products = prdts.products.filter(
      (x) => x.isoCountry === this.isoCountry
    );
  },
};
</script>

<style scoped>
.top-buffer {
  margin-bottom: 200px;
}
</style>